import { useCallback, useState } from "react";
import { useSelector } from "react-redux";

import PageTitle from "../../components/pageTitle";
import { StoreState } from "../../redux/reduxTypes";
import { EspelhoProducaoState, UserSession } from "../../types/state.types";
import {
  AreaCooperado,
  AreaData,
  AreaInfo,
  AreaResumoTabela,
  ColunasDescricao,
  ContainerPagina,
  LinhasTabela,
  TabelaConteudo
} from "./styled";

import { getSessionConfig } from "../../utils/session-helper";
import { useNavigate } from "react-router-dom";
import Button from "../../components/button";
import routes from "../../routes/routes.path";

function EspelhoProducaoImprimir() {
  const {
    filtrosBuscados,
    dadosEspelho,
    dadosEspelhoResumo,
  } = useSelector<StoreState, EspelhoProducaoState>(state => state.espelhoProducaoState);
  const userData = useSelector<StoreState, (UserSession | undefined)>(state => state.loginState.userData);
  const navigate = useNavigate();
  const [cooperativaSessionData] = useState(getSessionConfig());

  const irParaRelatorio = useCallback(() => {
    navigate(routes.EspelhoProducao);
  }, [navigate]);

  const imprimirPagina = useCallback(() => {
    window.print();
    // irParaRelatorio();
  }, [/* irParaRelatorio */]);

  return (
  <ContainerPagina>
    <PageTitle titulo="Espelho de Produção" />
    
    <section className="btnGroup">
      <Button primary onClick={imprimirPagina}>Imprimir</Button>
      <Button primary onClick={irParaRelatorio}>Voltar</Button>
    </section>

    {dadosEspelho ? <TabelaConteudo className="print">
      <tbody>
        <tr>
          <td>
            <header>
              <AreaData>
                <tbody>
                  <tr>
                    <td>
                      {new Date().toLocaleDateString(
                        'pt-Br',
                        {
                          weekday: 'long',
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric',
                        }
                      )}
                    </td>
                  </tr>
                </tbody>
              </AreaData>
              <AreaInfo>
                <tbody>
                  <tr>
                    <td>
                    <img
                      src={"data:image/png;base64, " + cooperativaSessionData.Logo}
                      alt={`Logotipo - ${cooperativaSessionData.Nome?.split(" ")[0]}`}
                    />
                    </td>
                    <td className="containerInfos">
                      <span>
                        <strong>ESPELHO DE PRODUÇÃO</strong><br />
                        PERÍODO: &nbsp;
                        <strong>
                          {filtrosBuscados.dataInicio.split('-').reverse().join('/')}
                          &nbsp;à&nbsp;
                          {filtrosBuscados.dataFim.split('-').reverse().join('/')}
                        </strong>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </AreaInfo>
              <AreaCooperado>
                <tbody>
                  <tr>
                    <td>Cooperado: <strong>{userData ? userData.Nome : ''}</strong></td>
                    <td>Matricula: <strong>{userData ? userData.Matricula : ''}</strong></td>
                    <td>Lotacao: <strong>{dadosEspelho[0].Lotacao}</strong></td>
                  </tr>
                </tbody>
              </AreaCooperado>
            </header>

            <ColunasDescricao>
            <tbody>
              <tr>
                <td>Dia Semana</td>
                <td>Função</td>
                <td>Setor</td>
                <td>Data Entrada</td>
                <td>Data Saída</td>
                <td>Tipo Plantão</td>
                <td>Carga Horária</td>
              </tr>
            </tbody>
            </ColunasDescricao>
            <main>
              <LinhasTabela>
                <tbody>
                    {dadosEspelho ?
                    dadosEspelho.map((espelho, i) => {
                      return (
                      <tr key={i}>
                        <td>
                          {espelho.DiaSemana}
                        </td>
                        <td>
                          {espelho.Funcao}
                        </td>
                        <td>
                          {espelho.Setor}
                        </td>
                        <td>
                          {espelho.DescricaoData + ' ' + espelho.DescricaoHoraInicio}
                        </td>
                        <td>
                          {espelho.HoraFim && espelho.HoraFim !== null ?
                          espelho.HoraFim.split('T')[0].split('-').reverse().join('/')
                          + ' ' + espelho.DescricaoHoraFim
                          : ' -- '
                          }
                        </td>
                        <td>
                          {espelho.Turno}
                        </td>
                        <td>
                          {espelho.DescricaoHoras ? espelho.DescricaoHoras : ' -- '}
                        </td>
                      </tr>
                      )
                    }) : <></>}
                </tbody>
              </LinhasTabela>
              
              <AreaResumoTabela>
                {
                  dadosEspelhoResumo?
                  <>
                    {<tbody dangerouslySetInnerHTML={{__html: dadosEspelhoResumo}} />}
                  </> : <></>
                }
              </AreaResumoTabela>
            </main>
          </td>
        </tr>
      </tbody>
    </TabelaConteudo>
    : <></>}
  </ContainerPagina>
  );
}

export default EspelhoProducaoImprimir;
